import api from "../service/api";

export const changePassword = (id, user) => {
  return api.post(`/change-password/${id}`, user);
};